import React from 'react'
import {Polar} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'


//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const PolarChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Polar,
            {className:className,attribute},
            children
        )
    )
}

PolarChart.propTypes=propsType;
PolarChart.defaultProps=defaultProps;

export default PolarChart;